import "./modules/common";
import { StateManager, StateWrapper } from "spiritweb.packages.web-account";
import VueApp from "~/Scripts/new/vueApp";
import MagazineLauncher from "~/Components/Magazines/MagazineLauncher.vue";
import MagazineAccordion from "~/Components/Magazines/MagazineAccordion.vue";
import CardSlider from "~/Components/Pagination/CardSlider.vue";
import DefaultCard from "~/Components/Search/Results/Default.vue";
import MagazineReviews from "~/Components/Magazines/MagazineReviews.vue";
import MagazineSubscription from "~/Components/Magazines/MagazineSubscription.vue";
import PricingInformation from "~/Components/Magazines/PricingInformation.vue";
import SubscriptionOrgRequester from "~/Components/Accounts/SubscriptionOrgRequester.vue";

new VueApp( {
  name: "MagazinesSubscriptionPage",
  components: {
    MagazineLauncher,
    MagazineAccordion,
    MagazineReviews,
    MagazineSubscription,
    CardSlider,
    StateManager,
    StateWrapper,
    PricingInformation,
    SubscriptionOrgRequester,
  },
  data: {
    activeMagazine: undefined,
    defaultCard: DefaultCard,
  },
  methods: {
    setActiveMagazine ( id ) {
      this.activeMagazine = id;
    },
    isActiveMagazine ( id ) {
      return this.activeMagazine === id;
    },
    isInactiveMagazine ( id ) {
      return this.isActiveMagazine( id ) === false && this.activeMagazine !== undefined;
    },
    scrollToPricing () {
      const el = this.$refs["magazine-pricing"];
      this.scrollToElement( el );
    },
    scrollToElement ( element ) {
      element.scrollIntoView( {
        behavior: "smooth",
        block: "start",
      } );
    },
  },
} );
